/*
 * GH #2713: the snackbar never hides, so above the phone's 56px bottom navigation it sits clear of it. The doubled
 * class outranks the Snackbar primitive's own bottom offset whatever order the stylesheets load in.
 */
.aboveNavigation.aboveNavigation {
  bottom: calc(56px + 8px + env(safe-area-inset-bottom, 0px));
}

.visuallyHidden {
  position: absolute;
  width: 1px;
  height: 1px;
  margin: -1px;
  padding: 0;
  overflow: hidden;
  clip-path: inset(50%);
  white-space: nowrap;
  border: 0;
}
